export const ACTION_SPACE = 4_672;
export const MAX_STEPS = 512;

export const enum Piece {
  Empty = 0,
  Pawn = 1,
  Knight = 2,
  Bishop = 3,
  Rook = 4,
  Queen = 5,
  King = 6,
}

export type Color = 0 | 1;
export type Promotion = -1 | 0 | 1 | 2;

export interface ChessAction {
  from: number;
  to: number;
  underpromotion: Promotion;
}

export type TerminalReason =
  | "checkmate"
  | "stalemate"
  | "insufficient-material"
  | "fifty-move"
  | "threefold-repetition"
  | "max-steps"
  | "illegal-action";

export interface MoveRecord {
  action: number;
  uci: string;
}

export interface ChessState {
  readonly color: Color;
  readonly board: Int8Array;
  readonly boardHistory: readonly Int8Array[];
  /** [mine queenside, mine kingside, opponent queenside, opponent kingside]. */
  readonly castlingRights: readonly [boolean, boolean, boolean, boolean];
  readonly enPassant: number;
  readonly halfmoveCount: number;
  readonly fullmoveCount: number;
  readonly stepCount: number;
  readonly positionHistory: readonly string[];
  readonly moves: readonly MoveRecord[];
  readonly terminated: boolean;
  readonly truncated: boolean;
  readonly terminalReason: TerminalReason | null;
  /** Absolute white/black rewards. */
  readonly rewards: readonly [number, number];
}

